import { Merchant } from '@stax-core/types-omni';

/**
 * The `merchant_processor_application` value that identifies a PayFac merchant.
 *
 * Only this exact value counts as PayFac. Notably `fis_priority_combined` does
 * *not*, even though `getHellosignTemplate` maps it to the same HelloSign
 * template ID — the two are not interchangeable for flow decisions. This
 * matches the signup app, which forks purely on `processorApplication === 'payfac'`.
 */
export const PAYFAC_PROCESSOR_APPLICATION = 'payfac' as const;

/**
 * Whether this merchant is a PayFac merchant, per its processor application.
 *
 * This replaces the legacy `merchant.is_payfac` boolean as the discriminator for
 * every PayFac-vs-ISO decision (signing path, agreement copy, required payments
 * fields). The two fields can disagree in production data, and
 * `merchant_processor_application` is the one that determines which application
 * document the merchant actually signs.
 *
 * A merchant with no processor application is treated as non-PayFac, matching
 * the existing `|| 'iso'` fallback used when resolving a HelloSign template.
 */
export function isPayfacMerchant(
  merchant?: Pick<Merchant, 'merchant_processor_application'> | null,
): boolean {
  return (
    merchant?.merchant_processor_application === PAYFAC_PROCESSOR_APPLICATION
  );
}
